package dev.lingvo.site.components.editor

import dev.lingvo.shared.KeyRow
import dev.lingvo.shared.MtProvider
import dev.lingvo.shared.MtResultDto
import dev.lingvo.shared.pluralCategoriesFor
import dev.lingvo.site.i18n.tr
import dev.lingvo.site.i18n.trf

internal fun MtResultDto.insertabilityIssue(row: KeyRow, locale: String): String? {
    if (!row.key.isPlural) {
        return if (value.isNullOrBlank()) {
            tr("editor.editor_assist_result_validity.no_text_was_returned", "No text was returned.")
        } else {
            null
        }
    }
    val forms = pluralForms ?: return tr(
        "editor.editor_assist_result_validity.no_plural_forms_were_returned",
        "No plural forms were returned.",
    )
    val missing = pluralCategoriesFor(locale).firstOrNull { category ->
        forms[category].isNullOrBlank()
    }
    return missing?.let { category ->
        trf(
            "editor.editor_assist_result_validity.the_form_was_missing",
            "The {form} form was missing.",
            "form" to category.displayName(),
        )
    }
}

internal fun MutableMap<String, List<EditorSuggestion.Machine>>.removeProviderSuggestion(
    keyId: String,
    provider: MtProvider,
) {
    val retained = get(keyId).orEmpty().filterNot { suggestion ->
        suggestion.provider == provider
    }
    if (retained.isEmpty()) {
        remove(keyId)
    } else {
        set(keyId, retained)
    }
}
